import { RefObject } from "react";

import { MODAL_MESSAGES } from "../constants/modalMessages";

export const hasUnsavedTextareaInput = (
  containerRef: RefObject<HTMLElement>,
): boolean => {
  if (!containerRef.current) return false;
  const textareas = containerRef.current.querySelectorAll("textarea");
  return Array.from(textareas).some(
    textarea => textarea.value.trim().length > 0,
  );
};

type ModalType = "delete" | "edit" | "hide" | string;

interface GetModalMessageOptions {
  type: ModalType;
  hiddenBy?: null | unknown;
}

export const getConfirmModalMessage = ({
  type,
  hiddenBy,
}: GetModalMessageOptions): string => {
  if (type === "delete") {
    return MODAL_MESSAGES.DELETE_COMMENT;
  }
  if (type === "edit") {
    return MODAL_MESSAGES.DISCARD_EDIT;
  }
  if (type === "hide") {
    return hiddenBy === null
      ? MODAL_MESSAGES.HIDE_COMMENT
      : MODAL_MESSAGES.SHOW_COMMENT;
  }
  return "";
};
